import axiosClient from "api/axios_client.js";

const SOURCE = "/reminder-builder/reminder-setup/source";

// Source calls shared by the Reminder Setup tabs (Source, Source Field). Calls Reminder Library needs too are in
// ../api.js.
const apiReminderSetup = {
  // Columns and relations of the root model, or of the model reached through `path` (one level at a time).
  getModelSchema: (model, path) => axiosClient.post(`${SOURCE}/get-model-schema`, { model, ...(path ? { path } : {}) }),
};

export default apiReminderSetup;
